<template>
<div class="container">
 <div class="row instagram-feed" id="instaFeed">
    <div class="insta-title">
        <h2><img src="../assets/img/instagram-solo.svg" class="img-responsive" style="display: inline;height:60px;" />From Instagram</h2>
    </div>
    <div class="row post-row">
        <div class="posts col-md-2 col-sm-4" v-for="post of posts" :key="post.id" >
                <a class=""  :href='post.permalink' target="_blank" :style="{'background-image': 'url(' + post.media_url + ')'}"><!--<img class="img-fluid" :src="post.media_url" /><--></a>
        </div>
    </div>
</div>
</div>
</template>
<script>
import InstaFeed from '../services/instagram.js'
export default {
    name: 'Instagram',
    data() {
        return {
            posts: []
        }
    },
    
    created() {
        InstaFeed.getPosts().then(posts => {
            this.posts = posts;
        });
    }
    }
</script>
<style lang="scss">
.instagram-feed {
    margin-left: 0px;
    margin-right: 0px;
    padding-top: 50px;
    padding-bottom: 50px;
   
   // background-color: #F8E1EA;
    .post-row {
        padding-left: 30px;
        padding-right: 30px;
        margin-left: 0px;
        @media only screen and (max-width: 599px){
            .col-md-2{
                width: 49%;
            }  
        }
        @media only screen and (min-width: 600px) and (max-width: 800px){
            .col-md-2{
                width: 33%;
            }  
        }

    }
    .posts {
        width: auto;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        //margin-bottom: 10px;
        padding:0px;
        a {
            display: block;
            width: 20vw;
            height: 10vw;
            background-size: cover;
            @media only screen and (max-width: 500px) {
                width: 50vw;
                height: 50vw;
            }
        }
        img {
            width: 100%;
            height: 100%;
            
        }
    }
    h2 {
        font-family: "lust-script",sans-serif;
        font-size: 3em;
        color: #300B02;
    }
    .insta-title {
        padding-left: 25px;
        padding-bottom: 25px;
    }

}

</style>